// 管理员菜单

let menuAdmin = [
    
    // {
    //     path:'/',
    //     component: "HomeView",
    //     redirect: '/home/IndexView',
    //     name: '首页',
    //     parent:true,
    //     children:[
    //         {
    //             pageAddress:"IndexView",
    //             path:"/home/IndexView",
    //             component:"IndexView",
    //             name:"实时数据",
    //         }
    //     ]

    // },
    {
        path: '/p0',
        component: "HomeView",
        name: '营销管理',
        redirect:'/common/injuriesList',
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"公关管理",
                children:[
                    // {
                    //     pageAddress:"commonPage/projectManage/injuriesList",
                    //     path:"/common/injuriesList",
                    //     name:"事故管理",
                    // },
                    {
                        pageAddress:"commonPage/projectManage/injuriesDetail",
                        path:"/common/injuriesDetail",
                        component:"injuriesDetail",
                        name:"事故详情",
                        hidden:true,
                    },
                    {
                        pageAddress:"commonPage/projectManage/injuriesAdd",
                        path:"/common/injuriesAdd",
                        component:"injuriesAdd",
                        name:"添加伤亡事故",
                        hidden:true,
                    },
                    {
                        pageAddress:"pm/pmInjuriesList",
                        path:"/pm/pmInjuriesList",
                        hidden:true,
                        component:"pmInjuriesList",
                        name:"伤亡事故"
                    },
                    // {
                    //     pageAddress:"commonPage/complaintManage/complaintList",
                    //     path:"/common/complaintList",
                    //     component:"complaintList",
                    //     name:"投诉管理"
                    // },	
                    {
                        pageAddress:"commonPage/complaintManage/addComplainList",
                        path:"/common/addComplainList",
                        hidden:true, 
                        component:"addComplainList",
                        name:"添加投诉"
                    },
                    {
                        pageAddress:"commonPage/complaintManage/complaintDetail",
                        path:"/common/complaintDetail",
                        hidden:true, 
                        component:"complaintDetail",
                        name:"投诉详情"
                    }
                ]
            },
            {
                parent:true,
                component:"Navigation",
                redirect:'/common/problemFeedbackList',
                path:"/home",
                name:"反馈管理",
                children:[
                    // {
                    //     path:"/common/problemFeedbackList",
                    //     component:"ProblemFeedbackView",
                    //     name:"问题反馈"
                    // },
                    {
                        path:"/common/problemFeedbackDetail",
                        hidden:true,
                        component:"ProblemFeedbackDetailView",
                        name:"问题反馈详情"
                    },
                ]
            },
        ]
    },
    // {
    //     path:'/p1',
    //     redirect: '/common/projectPreparation',
    //     component: "HomeView",
    //     name: '运营管理',
    //     parent:true,
    //     children:[
    //         {
    //             parent:true,
    //             component:"Navigation",
    //             path:"/home",
    //             name:"报备管理",
    //             children:[
    //                 // {               
    //                 //     pageAddress:"commonPage/projectManage/projectPreparation", 
    //                 //     path:"/common/projectPreparation",
    //                 //     component:"projectPreparation",
    //                 //     name:"项目报备",
    //                 // },
    //                 {               
    //                     pageAddress:"commonPage/projectManage/proPreparationModify", 
    //                     path:"/common/proPreparationModify",
    //                     component:"proPreparationModify",
    //                     hidden:true,
    //                     name:"编辑项目报备",
    //                 },
    //                 {               
    //                     pageAddress:"commonPage/projectManage/proPreparationAdd", 
    //                     path:"/common/proPreparationAdd",
    //                     component:"proPreparationAdd",
    //                     hidden:true,
    //                     name:"新增项目报备",
    //                 },
    //                 {
    //                     pageAddress:"commonPage/projectManage/proPreparationDetail", 
    //                     path:"/common/proPreparationDetail",
    //                     hidden:true,
    //                     name:"项目报备详情",
    //                 },
    //                 // {
    //                 //     pageAddress:"cm/CMConflictProject",
    //                 //     path:"/cm/project/conflictProject",
    //                 //     component:"CMConflictProject",
    //                 //     name:"撞单项目"
    //                 // },
    //                 {
    //                     pageAddress:"commonPage/projectManage/conflictProject",
    //                     path:"/common/conflictProject",
    //                     component:"conflictProject",
    //                     hidden:true,
    //                     name:"撞单项目详情"
    //                 },
    //             ]
    //         },
    //         {
    //             parent:true,
    //             component:"Navigation",
    //             path:"/home",
    //             name:"项目进度",
    //             children:[
    //                 // {   
    //                 //     pageAddress:"cm/CMValidProjectIndexView",             
    //                 //     path:"/cm/project/followUpProject",
    //                 //     component:"CMValidProjectIndexView",
    //                 //     name:"在跟项目",
    //                 // },				
    //                 // {
    //                 //     pageAddress:"cm/CMRunningProjectIndexView",
    //                 //     path:"/cm/project/underConstructionProject",
    //                 //     name:"在建项目"
    //                 // },  
    //                 // {
    //                 //     pageAddress:"cm/CMFinishedIndexView",
    //                 //     path:"/cm/project/finishedProject",
    //                 //     component:"CMFinishedIndexView",
    //                 //     name:"已完工项目"
    //                 // },
    //                 {
    //                     pageAddress:"cm/CMRunningProjectEditView",
    //                     path:"/cm/project/track",
    //                     hidden:true,
    //                     component:"CMRunningProjectEditView",
    //                     name:"在建项目详情"
    //                 },
    //                 {
    //                     pageAddress:"cm/CMRunningProjectEditView",
    //                     path:"/cm/finishProject/track",
    //                     hidden:true,
    //                     component:"CMRunningProjectEditView",
    //                     name:"已完工项目详情"
    //                 },
    //                 {
    //                     pageAddress:"cm/CMTempProjectEditView", 
    //                     path:"/cm/temp_project/edit",
    //                     hidden:true,
    //                     component:"CMTempProjectEditView",
    //                     name:"编辑"
    //                 },
    //                 {
    //                     pageAddress:"cm/CMTempProjectReadView", 
    //                     path:"/cm/temp_project/read_view",
    //                     hidden:true,
    //                     name:"在跟项目详情"
    //                 },
    //                 // {
    //                 //     pageAddress:"commonPage/projectManage/losingList",
    //                 //     path:"/common/losingList",
    //                 //     component:"losingList",
    //                 //     name:"丢单项目"
    //                 // },
    //                 {               
    //                     pageAddress:"commonPage/projectManage/proPreparationDetail", 
    //                     path:"/common/losingDetail",
    //                     component:"proPreparationDetail",
    //                     hidden:true,
    //                     name:"丢单项目详情",
    //                 },
    //                 // {
    //                 //     pageAddress:"commonPage/projectManage/projectQueryList",
    //                 //     path:"/common/projectQueryList",
    //                 //     component:"projectQueryList",
    //                 //     name:"项目查询"
    //                 // },
    //                 // {
    //                 //     pageAddress:"commonPage/projectManage/fileList",
    //                 //     path:"/common/fileList",
    //                 //     component:"fileList",
    //                 //     name:"项目资料管理"
    //                 // },
    //                 {
    //                     pageAddress:"commonPage/projectManage/fileDetail",
    //                     path:"/common/fileDetail",
    //                     component:"fileDetail",
    //                     hidden:true,
    //                     name:"项目资料详情"
    //                 },
    //             ]
    //         },
    //     ]

    // },
    // {
    //     path:'/p2',
    //     redirect: '/common/CMcontractData',
    //     component: "HomeView",
    //     name: '合同管理',
    //     parent:true,
    //     children:[
    //         {
    //             parent:true,
    //             component:"Navigation",
    //             path:"/home",
    //             name:"合同管理",
    //             children:[
    //                 // {
    //                 //     pageAddress:"cm/CMcontractData",
    //                 //     path:"/common/CMcontractData",
    //                 //     component:"contractData",
    //                 //     name:"合同总纲",
    //                 //     meta:{
    //                 //         keepAlive:true,
    //                 //     }
    //                 // },
    //                 {
    //                     pageAddress:"commonPage/dataReport/contractDataInfo",
    //                     path:"/common/contractDataInfo",
    //                     component:"contractDataInfo",
    //                     hidden:true,
    //                     name:"合同总纲详情",
    //                 },
    //                 {
	// 					pageAddress:"CommonContractReadView0",
	// 					path:"/cm/contract/read_view0",
	// 					hidden:true,
	// 					name:"合同详情"
	// 				},
    //                 // {
    //                 //     pageAddress:"cm/CMContractIndexView",
    //                 //     path:"/cm/project/contractIndex",
    //                 //     component:"CMContractIndexView",
    //                 //     name:"待审合同"
    //                 // },
                    
    //                 {
    //                     pageAddress:"CommonContractAuditView",
    //                     path:"/common/contract/CommonContractEditView",
    //                     hidden:true,
    //                     name:"审核合同"
    //                 },
    //                 {
    //                     pageAddress:"CommonContractReadView",
    //                     path:"/common/contract/CommonContractReadView",
    //                     hidden:true,
    //                     name:"合同详情"
    //                 },
    //                 // {
    //                 //     pageAddress:"cm/CMProjectModifyList",
    //                 //     path:"/cm/project/CMProjectModifyList",
    //                 //     component:"CMProjectModifyList",
    //                 //     name:"变更合同"
    //                 // },
    //                 {
    //                     pageAddress:"CommonContractModifyCheck",
    //                     path:"/common/contractModify/CommonContractModifyCheck",
    //                     hidden:true,
    //                     name:"变更合同审核"
    //                 },
    //                 {
    //                     pageAddress:"CommonContractModifyDetail",
    //                     path:"/common/contractModify/CommonContractModifyDetail",
    //                     hidden:true,
    //                     name:"变更合同详情"
    //                 },
    //             ]
    //         },
    //         {
    //             parent:true,
    //             component:"Navigation",
    //             path:"/home",
    //             name:"印章管理",
    //             children:[
    //                 // {
    //                 //     pageAddress:"fm/FMSealList",
    //                 //     path:"/fm/FMSealList",
    //                 //     name:"用章记录"
    //                 // },
    //                 {
    //                     pageAddress:"fm/FMSealDetail",
    //                     path:"/fm/FMSealDetail",
    //                     name:"用章详情",
    //                     hidden:true,
    //                 },
    //             ]
    //         }
    //     ]

    // },
    // {
    //     path: '/p3',
    //     component: "HomeView",
    //     name: '工程管理',
    //     redirect:'/common/engineerList0',
    //     parent:true,
    //     children:[
    //         {
    //             parent:true,
    //             component:"Navigation",
    //             path:"/home",
    //             name:"质监管理",
    //             children:[
    //                 // {
    //                 //     pageAddress:"commonPage/enginnerManage/engineerList0",
    //                 //     path:"/common/engineerList0",
    //                 //     component:"engineerList",
    //                 //     name:"工程总表"
    //                 // },
    //                 // {
    //                 //     pageAddress:"commonPage/broadHeading/AllocationOfItems",
    //                 //     path:"/common/AllocationOfItems",
    //                 //     component:"engineerList",
    //                 //     name:"项目分配"
    //                 // },
    //                 // {
    //                 //     pageAddress:"commonPage/broadHeading/LargeProject",
    //                 //     path:"/common/LargeProject",
    //                 //     component:"engineerList",
    //                 //     name:"大项目管理"
    //                 // },
    //                 {
    //                     pageAddress:"commonPage/enginnerManage/engineerDetail",
    //                     path:"/common/engineerDetail",
    //                     hidden:true, 
    //                     component:"engineerDetail",
    //                     name:"工程详情"
    //                 },
    //                 // {
    //                 //     pageAddress:"commonPage/enginnerManage/constructionScoreList",
    //                 //     path:"/common/constructionScoreList",
    //                 //     component:"constructionScoreList",
    //                 //     name:"工地检查评分统计表"
    //                 // },
    //                 // {
    //                 //     pageAddress:"commonPage/enginnerManage/pmAllGradeList",
    //                 //     path:"/common/pmAllGradeList",
    //                 //     component:"pmAllGradeList",
    //                 //     name:"项目总监各工地评分汇总表"
    //                 // },
    //                 // {
    //                 //     pageAddress:"commonPage/enginnerManage/returnVisit",
    //                 //     path:"/common/returnVisit",
    //                 //     component:"returnVisit",
    //                 //     name:"电话回访评分表"
    //                 // },
    //                 // {
    //                 //     pageAddress:"commonPage/enginnerManage/supervisorExamList",
    //                 //     path:"/common/supervisorExamList",
    //                 //     component:"supervisorExamList",
    //                 //     name:"工程监理考评表"
    //                 // },	
    //             ]
    //         },
            
    //     ]
    // },
    {
		path:'/p4',
        redirect: '/common/materialList',
        component: "HomeView",
        name: '材料管理',
        parent:true,
        // 列表页meta路由是否缓存
        // meta: {
        //     requiresAuth: true,
        //     privilege: ['capacityStatus'],
        //     keepAlive: true,//此组件需要被缓存
        //     isBack: false, //用于判断上一个页面是哪个
        // },

        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"代付材料",
                children:[
                    // {
                    //     pageAddress:"commonPage/financeManage/materialList",
                    //     path:"/common/materialList",
                    //     name:"代付申请"
                    // },
                    {
                        pageAddress:"commonPage/financeManage/materialDetail",
                        path:"/common/materialDetail",
                        hidden:true,
                        name:"代付材料申请详情",

                        // 详情页面返回列表页要去被缓存
                        // meta: {
                        //     requiresAuth: true,
                        //     privilege: ['capacityStatus'],
                        // }

                    },
                    {
                        pageAddress:"commonPage/financeManage/marginDetail",
                        path:"/common/marginDetail",
                        hidden:true,
                        name:"代付投标保证金申请详情"
                    },
                    {
                        pageAddress:"commonPage/financeManage/depositDetail",
                        path:"/common/depositDetail",
                        hidden:true,
                        name:"代付物业押金申请详情"
                    },
                    // {
                    //     pageAddress:"commonPage/financeManage/purchaseList",
                    //     path:"/common/purchaseList",
                    //     name:"材料购销合同"
                    // },
                    {
                        pageAddress:"commonPage/financeManage/purchaseDetail",
                        path:"/common/purchaseDetail",
                        hidden:true,
                        name:"材料购销合同详情"
                    },
                    {
                        pageAddress:"commonPage/financeManage/purchaseApply",
                        path:"/common/purchaseApply",
                        hidden:true,
                        name:"新增材料购销合同"
                    },
                ]
            },
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"众惠材料",
                children:[
                    // {
                    //     pageAddress:"commonPage/financeManage/zhotyImportList",
                    //     path:"/common/zhotyImportList",
                    //     name:"材料导入记录"
                    // },
                ]
            }
        ]

    },
    {
        path:'/p5',
        redirect: '/fm/FMStatProjectIndexView',
        component: "HomeView",
        name: '财务管理',
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"总表视图",
                children:[
                    // {
                    //     pageAddress:"fm/FMStatProjectIndexView",
                    //     path:"/fm/FMStatProjectIndexView",
                    //     name:"项目视图"
                    // },
                    // {
                    //     pageAddress:"commonPage/dataReport/financeData",
                    //     path:"/common/financeData",
                    //     component:"financeData",
                    //     name:"财务总表",
                    //     meta:{
                    //         keepAlive:true,
                    //     }
                    // },
                    {
                        pageAddress:"commonPage/dataReport/financeDataInfo",
                        path:"/common/financeDataInfo",
                        component:"financeDataInfo",
                        hidden:true,
                        name:"财务数据详情"
                    },
                    
                    {
                        pageAddress:"fm/FMStatProjectReadView",
                        path:"/fm/FMStatProjectReadView",
                        hidden:true,
                        name:"项目细节"
                    }
                ]
            },
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"资金管理",
                children:[
                    // {
                    //     pageAddress:"fm/FMFinanceIncomeIndexView",
                    //     path:"/fm/FMFinanceIncomeIndexView",
                    //     name:"收款流水"
                    // },
                    {
                        pageAddress:"fm/FMFinanceIncomeEditView",
                        path:"/fm/financeIncome/edit",
                        hidden:true,
                        name:"收款流水细节"
                    },	
                    {
                        pageAddress:"fm/FMFinanceIncomeReadView",
                        path:"/fm/financeIncome/read",
                        hidden:true,
                        name:"流水信息"
                    },
                    // { 
                    //     path: '/finance/insurance',
                    //     component:'insuranceList',
                    //     name: '保险记录',
                    //     pageAddress:"finance/insuranceList",
                    // },
                    // {
                    //     pageAddress:"commonPage/financeManage/servicePayList",
                    //     path:"/common/servicePayList",
                    //     name:"劳务支付"
                    // },
                    {
                        pageAddress:"commonPage/financeManage/servicePayEdit",
                        path:"/common/servicePayEdit",
                        hidden:true,
                        name:"编辑劳务支付"
                    },
                    {
                        pageAddress:"commonPage/financeManage/servicePayDetail",
                        path:"/common/servicePayDetail",
                        hidden:true,
                        name:"劳务支付详情"
                    },	
                    // {
                    //     pageAddress:"fm/FMDeductionList",
                    //     path:"/fm/FMDeductionList",
                    //     name:"手动扣款", 
                    // },
                    {
                        pageAddress:"fm/FMDeductionDetail",
                        path:"/fm/FMDeductionDetail",
                        hidden:true,
                        name:"手动扣款详情", 
                    },	
                    {
                        pageAddress:"fm/FMAddDeduction",
                        path:"/fm/FMAddDeduction",
                        hidden:true,
                        name:"添加手动扣款", 
                    },				
                                        
                    {
                        pageAddress:"fm/FMStatProjectReadView",
                        path:"/fm/FMStatProjectReadView",
                        hidden:true,
                        name:"项目细节"
                    },	
                    // {
                    //     pageAddress:"commonPage/financeManage/applyPaymentList",
                    //     path:"/common/applyPaymentList",
                    //     meta: {
                    //         keepAlive: true // 需要被缓存
                    //     },
                    //     name:"用款申请"
                    // },
                    {
                        pageAddress:"commonPage/financeManage/applyPaymentDetail",
                        path:"/common/applyPaymentDetail",
                        hidden:true,
                        name:"用款申请详情"
                    },	
                ]
            },
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"发票管理",
                children:[
                    // {
                    //     pageAddress:"fm/FmOutPutTicket",
                    //     path:"/fm/FmOutPutTicket",
                    //     name:"销项票"
                    // },		
                    {
                        pageAddress:"fm/FmOutPutTicketDetail",
                        path:"/fm/FmOutPutTicketDetail",
                        hidden:true,
                        name:"开票详情"
                    },	
                    {
                        pageAddress:"fm/FmAddOutPutTicket",
                        path:"/fm/FmAddOutPutTicket",
                        hidden:true,
                        name:"添加开票"
                    },	
                ]
            },
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"授信管理",
                children:[
                    // {
                    //     pageAddress:"commonPage/CreditList",
                    //     path:"/common/creditList",
                    //     component:"CreditList",
                    //     name:"授信提额"
                    // },
                    {
                        pageAddress:"commonPage/CreditDetail",
                        path:"/common/creditDetail",
                        hidden:true, 
                        component:"CreditDetail",
                        name:"授信详情"
                    }	
                ]
            },
        ]

    },
    {
        path:'/p6',
        redirect: '/cm/pm/projectManagerList',
        component: "HomeView",
        name: '项目总监管理',
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"项目总监",
                children:[
                    // {
                    //     pageAddress:"ProjectManagerListView",
                    //     path:"/ba/cm/projectManagerList",
                    //     component:"ProjectManagerListView",
                    //     name:"项目总监总表"
                    // },
                    {
                        pageAddress:"cd/pmBlackDetail",
                        path:"/cd/pm/pmBlackDetail",
                        component:"pmBlackDetail",
                        name:"项目总监详情",
                        hidden:true,
                    },
                    {
                        pageAddress:"cm/CMProjectManagerEditView",
                        path:"/cm/pm/add",
                        component:"CMProjectManagerEditView",
                        name:"添加项目总监",
                        hidden:true,
                    },
                    {
                        pageAddress:"cm/CMProjectManagerEditView",
                        path:"/cm/pm/edit",
                        hidden:true,
                        component:"CMProjectManagerEditView",
                        name:"编辑项目总监"
                    },
                    {
                        pageAddress:"cm/CMProjectManagerReadView", 
                        path:"/cm/pm/read_view",
                        hidden:true,
                        component:"CMProjectManagerReadView",
                        name:"项目总监信息(只读)"
                    },
                    // {
                    //     pageAddress:"cm/CMIntroducerIndexView",
                    //     path:"/cm/introducer/index",
                    //     component:"CMIntroducerIndexView",
                    //     name:"项目总监关系管理"
                    // },
                    {
                        pageAddress:"cm/CMIntroducerAddView",
                        path:"/cm/introducer/edit",
                        hidden:true,
                        component:"CMIntroducerAddView",
                        name:"介绍人编辑"
                    },
                    {
                        pageAddress:"cm/CMIntroducerInfoView",
                        path:"/cm/introducer/info",
                        hidden:true,
                        component:"CMIntroducerInfoView",
                        name:"查看介绍人"
                    },
                    {
                        pageAddress:"cm/CMIntroducerInfo",
                        path:"/cm/introducer/infor",
                        hidden:true,
                        name:"项目总监关系管理详情"
                    },
                    {
                        pageAddress:"cd/CDProjectManagerEditView",
                        path:"/cd/pm/edit",
                        hidden:true,
                        component:"CDProjectManagerEditView",
                        name:"项目总监详情"
                    },
                    {
                        pageAddress:"cd/CDprojectInformation",
                        path:"/cd/pm/projectInformation",
                        hidden:true,
                        component:"CDprojectInformation",
                        name:"查看项目总监项目信息"
                    },
                    // {
                    //     pageAddress:"commonPage/pmManage/pmInterviewList",
                    //     path:"/common/pmInterviewList",
                    //     component:"pmInterviewList",
                    //     name:"项目总监访谈记录"
                    // },
                    {
                        pageAddress:"cd/CDinterviewRecord",
                        path:"/cm/pm/interviewRecord",
                        hidden:true,
                        component:"CDinterviewRecord",
                        name:"项目总监管理---访谈记录"
                    },
                    {
                        pageAddress:"cd/CDprojectDirector",
                        path:"/cm/pm/projectDirector",
                        hidden:true,
                        component:"CDprojectDirector",
                        name:"查看项目总监"
                    },
                    
                    {
                        pageAddress:"pm/pmComplaintList",
                        path:"/pm/pmComplaintList",
                        hidden:true,
                        component:"pmComplaintList",
                        name:"投诉处理"
                    },
                    {
                        pageAddress:"commonPage/pmManage/pmInterviewDetail",
                        path:"/common/pmInterviewDetail",
                        component:"pmInterviewDetail",
                        hidden:true,
                        name:"访谈记录详情"
                    },
                    {
                        pageAddress:"commonPage/pmManage/pmInterviewAdd",
                        path:"/common/pmInterviewAdd",
                        component:"pmInterviewAdd",
                        hidden:true,
                        name:"添加访谈记录"
                    },
                    // {
                    //     pageAddress:"cd/pmBlackList",
                    //     path:"/cd/pm/pmBlackList",
                    //     component:"pmBlackList",
                    //     name:"项目总监黑名单"
                    // },
                ]
            }
        ]

    },
    // {
	// 	path:'/p7',
    //     redirect: '/cm/customer/index',
    //     component: "HomeView",
    //     name: '客户管理',
    //     parent:true,
    //     children:[
    //         {
    //             parent:true,
    //             component:"Navigation",
    //             path:"/home",
    //             name:"客户管理",
    //             children:[
    //                 // {
    //                 //     pageAddress:"cm/CMCustomerIndexView",
    //                 //     path:"/cm/customer/index",
    //                 //     component:"CMCustomerIndexView",
    //                 //     name:"甲方管理"
    //                 // },
    //                 {
    //                     pageAddress:"cm/CMCustomerEditView", 
    //                     path:"/cm/customer/edit",
    //                     hidden:true,
    //                     component:"CMCustomerEditView",
    //                     name:"编辑甲方"
    //                 },
    //             ]
    //         },
    //     ]

    // },
    {
		path:'/p8',
        redirect: '/user/index',
        component: "HomeView",
        name: '系统管理',
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"账户设置",
                children:[
                    // { 
                    //     path: '/user/index',
                    //     pageAddress:"commonPage/UserIndexView",
                    //     component: "UserIndexView", 
                    //     name: '员工账号管理' 
                    // },
                    // { 
                    //     pageAddress:"RoleManagement",
                    //     path: '/user/RoleManagement',
                    //     component: "RoleManagement", 
                    //     name: '角色管理' 
                    // },
                    // { 
                    //     pageAddress:"OrganizationalManagement",
                    //     path: '/user/OrganizationalManagement',
                    //     component: "OrganizationalManagement", 
                    //     name: '组织架构管理' 
                    // },
                    
                     
                ]
            },
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"通用设置",
                children:[
                    // {                 
                    //     path: '/admin/sub_company/index', 
                    //     component: "SubCompanyIndexView", 
                    //     name: '新美子公司数据',
                    // },
                    {                 
                        path: '/admin/SubCompanyInfo', 
                        component: "SubCompanyInfo", 
                        hidden: true, 
                        name: '新美子公司详情',
                    },
                    {                 
                        path: '/admin/SubCompanyEditView', 
                        component: "SubCompanyEditView", 
                        hidden: true, 
                        name: '编辑子公司',
                    },
                    // { 
                    //     path: '/admin/operation_center/index', 
                    //     component: "OperationCenterView", 
                    //     name: '运营中心数据',
                    // },
                    // { 
                    //     path: '/admin/engineering/index', 
                    //     component: "EngineeringIndex", 
                    //     name: '公装类型' 
                    // },
                    // { 
                    //     path: '/admin/ProvincialUrban/index', 
                    //     component: "ProvincialUrbanIndex", 
                    //     name: '省市区数据' 
                    // },
                    // { 
                    //     path: '/admin/bank_name_data/index', 
                    //     component: "BankNameDataView", 
                    //     name: '银行数据' 
                    // },
                    // { 
                    //     path: '/admin/enum_cat/index', 
                    //     component: "EnumCatView", 
                    //     name: '枚举分类' 
                    // },
                    // { 
                    //     path: '/admin/enum_data/index', 
                    //     component: "EnumDataIndexView", 
                    //     name: '枚举数据' 
                    // },
                ]
            },
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"个人设置",
                children:[
                    // { 
                    //     path: '/me/change_password', 
                    //     component: "ChangePasswordView", 
                    //     name: '修改密码' 
                    // },	
                ]
            }
        ]

    },
    {
        pageAddress:"commonPage/dataReport/printSettleForm",
        path:"/common/printSettleForm",
        component:"printSettleForm",
        hidden:true,
        name:"打印结算表"
    }, 
    {
        pageAddress:"commonPage/financeManage/NewXiangmushitu",
        path:"/common/New",
        hidden:true,
        name:"项目视图新建页面导出数据"
    },
    {   
        pageAddress:"commonPage/financeManage/depositPrint",
        path:"/common/depositPrint",
        hidden:true,
        name:"打印物业押金"
    },
    {
        pageAddress:"commonPage/financeManage/marginPrint",
        path:"/common/marginPrint",
        hidden:true,
        name:"打印代付投标保证金"
    },
    {
        pageAddress:"commonPage/financeManage/materialPrint",
        path:"/common/materialPrint",
        hidden:true,
        name:"打印付款申请单"
    },
    {
        pageAddress:"commonPage/financeManage/serviceFeePrint",
        path:"/common/serviceFeePrint",
        hidden:true,
        // name:"打印劳务支付"
    },
    {
        pageAddress:"commonPage/enginnerManage/finishProjectTable",
        path:"/common/finishProjectTable",
        component:"finishProjectTable",
        hidden:true,
        // name:"竣工验收记录表"
    },
    {
        pageAddress:"commonPage/enginnerManage/startProjectTable",
        path:"/common/startProjectTable",
        component:"startProjectTable",
        hidden:true,
        // name:"开工确认单"
    },
    {
        pageAddress:"commonPage/enginnerManage/finishProjectTable",
        path:"/common/finishProjectTable",
        component:"finishProjectTable",
        hidden:true,
        // name:"竣工确认单"
    },
    {
        pageAddress:"commonPage/enginnerManage/constructionScoreDetail",
        path:"/common/constructionScoreDetail",
        component:"constructionScoreDetail",
        hidden:true,
        // name:"工地检查评分统计表"
    },
    {
        pageAddress:"commonPage/enginnerManage/returnVisitTable",
        path:"/common/returnVisitTable",
        component:"returnVisitTable",
        hidden:true,
        // name:"回访表"
    },
]

export default menuAdmin;


// WEBPACK FOOTER //
// ./src/menu/menuAdmin.js